<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="供应商初始报价查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_vend_initial_quote_search")}}</span>
        <VendInitialQuoteSearch></VendInitialQuoteSearch>
      </el-tab-pane>
      <el-tab-pane label="新建供应商初始报价">
        <span slot="label"><i class="iconfont icon-edit" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_vend_initial_quote_create")}}</span>
        <VendInitialQuoteAdd></VendInitialQuoteAdd>
      </el-tab-pane>
      <el-tab-pane label="导入">
        <span slot="label"><i class="iconfont icon-export-in" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_import")}}</span>
        <VendInitPurchaseQuoteExport :type_code="'outside'"></VendInitPurchaseQuoteExport>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VendInitialQuoteSearch from "./VendInitialQuoteSearch.vue";
import VendInitialQuoteAdd from "./VendInitialQuoteAdd.vue";
import VendInitPurchaseQuoteExport from "./VendInitPurchaseQuoteExport.vue";

export default {
  name: "VendPurchaseQuote",
  components: {
    VendInitialQuoteSearch,
    VendInitialQuoteAdd,
    VendInitPurchaseQuoteExport
  },
  data() {
    return {
      tab_index: 0,
    };
  },
  created() { },
  methods: {},
};
</script>
